export const getExperimentVariant = ({ assignments = {} } = {}) => (key) => {
  return Object.hasOwn(assignments, key) ? assignments[key] : null;
};

export const isInExperiment = ({ assignments = {} } = {}) => (key) => {
  return Object.hasOwn(assignments, key);
};

export const getPageViewEventId = ({ pageViewEventId }) => pageViewEventId;
